import { RefreshCw } from "lucide-react"
import { cn } from "@/lib/utils"

/** 1:1 Port von admin/templates.py:.page-header. */
export function PageHeader({
  title, count, onRefresh, refreshing, children,
}: {
  title: string
  count?: number
  onRefresh?: () => void
  refreshing?: boolean
  children?: React.ReactNode
}) {
  return (
    <div className="pp-page-header">
      <h2>
        {title}
        {count !== undefined && (
          <span className="page-count">({count})</span>
        )}
      </h2>
      <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
        {children}
        {onRefresh && (
          <button
            onClick={onRefresh}
            disabled={refreshing}
            className="pp-btn pp-btn-sm"
          >
            <RefreshCw className={cn("w-3 h-3", refreshing && "animate-spin")} />
            Aktualisieren
          </button>
        )}
      </div>
    </div>
  )
}
